import image1 from '../images/gallery/image11.jpeg';
import img1 from '../images/katani/katani1.jpeg';
import img2 from '../images/katani/katani2.jpeg';
import img3 from '../images/katani/katani3.jpeg';

//Juja Projects
import juja1 from '../images/juja/juja1.jpg';
import juja2 from '../images/juja/juja2.jpg';
import juja3 from '../images/juja/juja3.jpeg';
import juja4 from '../images/juja/juja4.jpg';
import juja5 from '../images/juja/juja5.jpg';
import juja6 from '../images/juja/juja6.jpeg';

//Matuu Projects
import matuu1 from '../images/matuu/matuu1.jpeg';
import matuu2 from '../images/matuu/matuu2.jpeg';
import matuu3 from '../images/matuu/matuu3.jpeg';  
import matuu4 from '../images/matuu/matuu4.jpeg';
import matuu5 from '../images/matuu/matuu5.jpeg';
import matuu6 from '../images/matuu/matuu6.jpeg';

//Joska Projects
import joska1 from '../images/joska/joska1.jpg';
import joska2 from '../images/joska/joska2.jpg';
import joska3 from '../images/joska/joska3.jpeg';  
import joska4 from '../images/joska/joska4.jpeg';
import joska5 from '../images/joska/joska5.jpeg';

//Malindi Projects
import malindi1 from '../images/malindi/malindi1.jpeg';
import malindi2 from '../images/malindi/malindi2.jpeg';
import malindi3 from '../images/malindi/malindi3.jpeg';  
import malindi4 from '../images/malindi/malindi4.jpeg';
import malindi5 from '../images/malindi/malindi5.jpeg';
import malindi6 from '../images/malindi/malindi6.jpeg';


//Kithyoko Projects
import kithyoko1 from '../images/kithyoko/kithyoko1.jpeg';
import kithyoko2 from '../images/kithyoko/kithyoko2.jpeg';
import kithyoko3 from '../images/kithyoko/kithyoko3.jpeg';  
import kithyoko4 from '../images/kithyoko/kithyoko4.jpeg';
import kithyoko5 from '../images/kithyoko/kithyoko5.jpeg';
import kithyoko6 from '../images/kithyoko/kithyoko6.jpeg';

export const gallery = [
  
    {
        id: 1,
        url: image1,
        title: 'Zuri Gardens Matuu',
        description: 'Zuri Gardens site visit',
    },
    { 
        id: 2, 
        url: img1,
        title: 'Katani Project',
        description: 'Amazing view of Katani project ',
    },
    { 
        id: 3, 
        url: img2,
        title: 'Katani Project',
        description: 'Amazing view of Katani project ',
    },
    { 
        id: 4, 
        url: img3,
        title: 'Katani Project',
        description: 'Amazing view of Katani project ',
    },
    { 
        id: 5, 
        url: juja1,
        title: 'Juja Project',
        description: 'Juja project view',
    },
    { 
        id: 6, 
        url: juja2,
        title: 'Juja Project',
        description: 'Juja project view',
    },
    { 
        id: 7, 
        url: juja3,
        title: 'Juja Project',
        description: 'Juja project view',
    },
    { 
        id: 8, 
        url: juja4,
        title: 'Juja Project',
        description: 'Juja project view',
    },
    { 
        id: 9, 
        url: juja5,
        title: 'Juja Project',
        description: 'Juja project view',
    },
    { 
        id: 10, 
        url: juja6,
        title: 'Juja Project',
        description: 'Juja project view',
    },
    { 
        id: 11, 
        url: matuu1,
        title: 'Matuu Project',
        description: 'Matuu project view',
    },
    { 
        id: 12, 
        url: matuu2,
        title: 'Matuu Project',
        description: 'Matuu project view',
    },
    { 
        id: 13, 
        url: matuu3,
        title: 'Matuu Project',
        description: 'Matuu project view',
    },
    { 
        id: 14, 
        url: matuu4,
        title: 'Matuu Project',
        description: 'Matuu project view',
    },
    { 
        id: 15, 
        url: matuu5,
        title: 'Matuu Project',
        description: 'Matuu project view',
    },
    { 
        id: 16, 
        url: matuu6,
        title: 'Matuu Project',
        description: 'Matuu project view',
    },
    { 
        id: 17, 
        url: joska1,
        title: 'Joska Project',
        description: 'Joska project view',
    },
    { 
        id: 18, 
        url: joska2,
        title: 'Joska Project',
        description: 'Joska project view',
    },
    { 
        id: 19, 
        url: joska3,
        title: 'Joska Project',
        description: 'Joska project view',
    },
    { 
        id: 20, 
        url: joska4,
        title: 'Joska Project',
        description: 'Joska project view',
    },
    { 
        id: 21, 
        url: joska5,
        title: 'Joska Project',
        description: 'Joska project view',
    },
    { 
        id: 22, 
        url: malindi1,
        title: 'Malindi Project',
        description: 'Malindi project view',
    },
    { 
        id: 23, 
        url: malindi2,
        title: 'Malindi Project',
        description: 'Malindi project view',
    },
    { 
        id: 24, 
        url: malindi3,
        title: 'Malindi Project',
        description: 'Malindi project view',
    },
    { 
        id: 25, 
        url: malindi4,
        title: 'Malindi Project',
        description: 'Malindi project view',
    },
    { 
        id: 26, 
        url: malindi5,
        title: 'Malindi Project',
        description: 'Malindi project view',
    },
    { 
        id: 27, 
        url: malindi6,
        title: 'Malindi Project',
        description: 'Malindi project view',
    },
    { 
        id: 28, 
        url: kithyoko1,
        title: 'Kithyoko Project',
        description: 'Kithyoko project view',
    },
    { 
        id: 29, 
        url: kithyoko2,
        title: 'Kithyoko Project',
        description: 'Kithyoko project view',
    },
    { 
        id: 30, 
        url: kithyoko3,
        title: 'Kithyoko Project',
        description: 'Kithyoko project view',
    },
    { 
        id: 31, 
        url: kithyoko4,
        title: 'Kithyoko Project',
        description: 'Kithyoko project view',
    },
    { 
        id: 32, 
        url: kithyoko5,
        title: 'Kithyoko Project',
        description: 'Kithyoko project view',
    },
    { 
        id: 33, 
        url: kithyoko6,
        title: 'Kithyoko Project',
        description: 'Kithyoko project view',
    },
];

export const video = [

    { 
        id: 'v1', 
        youtubeId: 'oX8TR_rpByA', 
        title: 'Zuri Land Investment Limited - Katani Project Overview',
    },

    
];